<div class="refresh-controls">
  <button
    type="button"
    class="refresh-btn"
    [disabled]="loading"
    (click)="onRefresh()"
    [matTooltip]="loading ? 'Refreshing…' : 'Refresh ' + subject + ' now'"
    matTooltipPosition="above"
    [attr.aria-label]="'Refresh ' + subject + ' now'"
  >
    <i class="pi" [class.pi-spinner]="loading" [class.pi-spin]="loading" [class.pi-refresh]="!loading" aria-hidden="true"></i>
  </button>

  <button
    type="button"
    class="auto-refresh-btn"
    [class.is-on]="enabled"
    [matMenuTriggerFor]="intervalMenu"
    [matTooltip]="'Choose how often ' + subject + ' refresh'"
    matTooltipPosition="above"
    aria-haspopup="menu"
    [attr.aria-label]="'Auto-refresh interval for ' + subject"
  >
    <i class="pi pi-history" aria-hidden="true"></i>
    <span class="auto-refresh-prefix">Auto-refresh:</span>
    <span class="auto-refresh-value">{{ intervalLabel }}</span>
    <i class="pi pi-chevron-down chevron" aria-hidden="true"></i>
  </button>

  <mat-menu #intervalMenu="matMenu" xPosition="before" yPosition="below" class="refresh-interval-menu">
    <button type="button" mat-menu-item [class.is-selected]="!enabled" (click)="select(0)">
      <span class="tick">@if (!enabled) {<i class="pi pi-check" aria-hidden="true"></i>}</span>
      <span>Off</span>
    </button>
    @for (interval of intervals; track interval.seconds) {
      <button type="button" mat-menu-item [class.is-selected]="seconds === interval.seconds" (click)="select(interval.seconds)">
        <span class="tick">@if (seconds === interval.seconds) {<i class="pi pi-check" aria-hidden="true"></i>}</span>
        <span>{{ interval.label }}</span>
      </button>
    }
  </mat-menu>
</div>
